import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const deliveryService = {
  getAllDeliveries,
  getDelivery,
  createDelivery,
  updateDelivery,
  updateDeliveryStatus,
  createDeliveryReturn,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.type) params.type = filter.type
  if (filter?.status) params.status = filter.status
  if (filter?.driverUuid) params.driver_uuid = filter.driverUuid
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

export function getAllDeliveries(filter) {
  return apiHelper(API_URL).get('/deliveries', { params: buildParams(filter) })
}
export function getDelivery(uuid) {
  return apiHelper(API_URL).get(`/deliveries/${uuid}`)
}
export function createDelivery(data) {
  return apiHelper(API_URL).post('/deliveries', data)
}
export function updateDelivery(uuid, data) {
  return apiHelper(API_URL).put(`/deliveries/${uuid}`, data)
}
export function updateDeliveryStatus(uuid, status, extra) {
  return apiHelper(API_URL).patch(`/deliveries/${uuid}/status`, {
    status,
    ...(extra || {}),
  })
}
export function createDeliveryReturn(uuid, data) {
  return apiHelper(API_URL).post(`/deliveries/${uuid}/return`, data)
}
